import React, { PropsWithChildren } from "react";
import { ListContextProvider, useListController } from "react-admin";

const CommonList: React.FC<PropsWithChildren<{ filters?: any }>> = ({ children, filters }) => {

    const listController = useListController<any>({
        sort: { field: "id", order: "DESC" },
        filter: filters || {}
    });

    return (
        <ListContextProvider value={listController}>
            <div className="w-full p-5">
                {children}
            </div>
        </ListContextProvider>
    );

};

export default CommonList;